module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 362
// module chunks = 0